export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Final (2)_05.dec10173.jpg";